import { Badge, Card, message, PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import {ButtonItem, TableItem} from "../../../Components/Items";
import moment from "moment";
import 'moment/locale/es'
import { connect } from "react-redux";
import { AppstoreOutlined, CheckCircleOutlined, EditOutlined, LockOutlined, MobileOutlined, SafetyCertificateOutlined, StopOutlined, TeamOutlined } from "@ant-design/icons";
import TabbedDynamicTable from "../../../Components/TabbedDynamicTable";
import AgregarUsuario from "./AgregarUsuario/AgregarUsuario";
import EditarUsuario from "./EditarUsuario/EditarUsuario";
import CambiarContrasena from "./CambiarContrasena/CambiarContrasena";
import ModalAccesoApp from "./ModalAccesoApp";
import AccesoProyectos from "./AccesoProyectos";

moment.locale('es')

const ROLES_BIWO = { contadorExterno: "Contador externo", soporteBiwo: "Soporte BIWO" };


class Usuarios extends Component {
  state = {
    todasUsuarios: [],
    loading: false,
    modalAgregarUsuario: false,
    modalEditarUsuario: false,
    modalEditarUsuarioId: null,
    modalCambiarContrasena: false,
    modalCambiarContrasenaId: null,
    modalAccesoApp: false,
    modalAccesoAppUsuario: null,
    usuarioMaster: null,
    tab: "usuarios",
  }
  componentDidMount() {
    this.consultarUsuarios();
    axios.post("usuariosBiwo/selectCatalogosUsuarios", {}, { headers: this.props.headersToken }).then((res) => {
      if (res.data.success === 2) this.setState({ departamentos: new Map(res.data.departamentos.map((d) => [d.clave, d.nombre])) });
    });
    if (this.props.tipo === 0) {
      this.consultarUsuarioMaster();
    }
  }

  consultarUsuarioMaster() {
    axios
      .post(
        "usuarios/datosUsuario",
        { usuarioId: this.props.usuarioPrincipal, usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data && res.data.status !== 404) {
          this.setState({ usuarioMaster: res.data });
        }
      })
      .catch(() => {});
  }

  consultarUsuarios() {
    this.setState({ loading: true });
    axios
    .post(
      "usuarios/selectUsuarios",
      { usuarioPrincipal: this.props.usuarioPrincipal },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      if (res.data.status === 404) {
        this.setState({ loading: false });
      } else {
        this.setState({
          loading: false,
          todasUsuarios: res.data.map(value => {
            return {
              ...value,
              nombre: value.nombre+' '+value.apellidoPaterno+' '+value.apellidoMaterno,
              perfilNombre: value.perfilNombre || value.perfil?.nombre || '',
              accion: { _id: value._id, estado: value.estado }
            }
          }),
        });
      }
    })
    .catch(() => this.setState({ loading: false }));
  }

  deshabilitarUsuario(value) {
    axios
      .post(
        "usuarios/deshabilitarUsuario",
        { usuarioId: value, usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Usuario deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.consultarUsuarios();
      });
  }
  habilitarUsuario(value) {
    axios
      .post(
        "usuarios/habilitarUsuario",
        { usuarioId: value, usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Usuario habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        this.consultarUsuarios();
      });
  }

  puedeCambiarEstado = (record) => {
    if (record.rolBiwo === "contadorExterno") return this.props.permisoUsuariosContadores;
    if (record.rolBiwo === "soporteBiwo") return this.props.permisoUsuariosSoporte;
    return this.props.permisoDeshabilitarUsuario;
  };

  resetearDosPasos(usuarioId) {
    axios
      .post("dosPasos/resetearUsuario", { usuarioId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Verificación en dos pasos reseteada");
        } else {
          message.error(res.data.message || "No se pudo resetear la verificación en dos pasos");
        }
        this.consultarUsuarios();
      })
      .catch(() => message.error("Error de conexión"));
  }

  abrirAgregarUsuario() {
    this.setState({ modalAgregarUsuario: true });
  }
  cerrarAgregarUsuario() {
    this.setState({ modalAgregarUsuario: false });
    this.consultarUsuarios();
  }
  abrirEditarUsuario(id) {
    this.setState({ modalEditarUsuario: true, modalEditarUsuarioId: id });
  }
  cerrarEditarUsuario() {
    this.setState({ modalEditarUsuario: false });
    this.consultarUsuarios();
  }
  abrirCambiarContrasena(id) {
    this.setState({ modalCambiarContrasena: true, modalCambiarContrasenaId: id });
  }
  cerrarCambiarContrasena() {
    this.setState({ modalCambiarContrasena: false });
    this.consultarUsuarios();
  }
  abrirAccesoApp(usuario) {
    this.setState({ modalAccesoApp: true, modalAccesoAppUsuario: usuario });
  }
  cerrarAccesoApp() {
    this.setState({ modalAccesoApp: false, modalAccesoAppUsuario: null });
    this.consultarUsuarios();
  }
  render() {
    const cmpStr = (k) => (a, b) => ((a[k] || '') < (b[k] || '') ? -1 : (a[k] || '') > (b[k] || '') ? 1 : 0);
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: cmpStr('nombre'),
      },
      {
        title: "Usuario",
        dataIndex: "nombreUsuario",
        key: "nombreUsuario",
        sorter: cmpStr('nombreUsuario'),
      },
      {
        title: "Perfil",
        dataIndex: "perfilNombre",
        key: "perfilNombre",
        responsive: ['md'],
        sorter: cmpStr('perfilNombre'),
      },
      {
        title: "Correo",
        dataIndex: "correoContacto",
        key: "correoContacto",
        responsive: ['md'],
        sorter: cmpStr('correoContacto'),
      },
      {
        title: "Celular",
        dataIndex: "celular",
        key: "celular",
        responsive: ['lg'],
        sorter: cmpStr('celular'),
      },
      {
        title: "Vendedor",
        dataIndex: "esVendedor",
        key: "esVendedor",
        responsive: ['lg'],
        align: 'center',
        render: (value) => value ? 'Sí' : 'No',
        sorter: (a, b) => (a.esVendedor ? 1 : 0) - (b.esVendedor ? 1 : 0),
      },
      {
        title: "Departamentos",
        dataIndex: "departamentos",
        key: "departamentos",
        responsive: ['lg'],
        render: (value) => (value || []).map((d) => <Tag key={d}>{this.state.departamentos?.get(d) || d}</Tag>),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        align: 'center',
        render: (value, record) => (
          <>
            <Badge
              status={value === 1 ? 'success' : 'error'}
              text={value === 1 ? 'Activo' : 'Inactivo'}
            />
            {record.rolBiwo && <Tag color="blue" style={{ marginLeft: 6 }}>{ROLES_BIWO[record.rolBiwo]}</Tag>}
          </>
        ),
        sorter: (a, b) => (a.estado || 0) - (b.estado || 0),
      },
      ...(this.props.tipo === 0
        ? [{
            title: "App",
            dataIndex: "accesoApp",
            key: "accesoApp",
            responsive: ['lg'],
            align: 'center',
            render: (value) => (
              <Tag color={value ? 'cyan' : 'default'}>
                {value ? 'Activo' : 'Inactivo'}
              </Tag>
            ),
            sorter: (a, b) => (a.accesoApp ? 1 : 0) - (b.accesoApp ? 1 : 0),
          }]
        : []),
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        responsive: ['xl'],
        sorter: (a, b) => {
          if (moment(a.createdAt) < moment(b.createdAt)) {
            return -1;
          }
          if (moment(a.createdAt) > moment(b.createdAt)) {
            return 1;
          }
          return 0;
        },
        render: (value) => moment(value).locale('es').format('ll'),
      },
      {
        title: 'Acción',
        dataIndex: 'accion',
        key: 'accion',
        align: 'center',
        render: (value, record) => (
          <div className="acciones-container">
            <Tooltip title={this.props.permisoEditarUsuario ? "Editar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.props.permisoEditarUsuario && this.abrirEditarUsuario(value._id)}
                disabled={!this.props.permisoEditarUsuario}
              />
            </Tooltip>
            {value.estado === 1 ? (
              <Popconfirm
                title="Seguro que quieres deshabilitar este usuario"
                onConfirm={() => this.deshabilitarUsuario(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!this.puedeCambiarEstado(record)}
              >
                <Tooltip title={this.puedeCambiarEstado(record) ? "Deshabilitar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                    disabled={!this.puedeCambiarEstado(record)}
                  />
                </Tooltip>
              </Popconfirm>
            ) : (
              <Popconfirm
                title="Seguro que quieres habilitar este usuario"
                onConfirm={() => this.habilitarUsuario(value._id)}
                okText="Si"
                cancelText="No"
                disabled={!this.puedeCambiarEstado(record)}
              >
                <Tooltip title={this.puedeCambiarEstado(record) ? "Habilitar" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                    disabled={!this.puedeCambiarEstado(record)}
                  />
                </Tooltip>
              </Popconfirm>
            )}
            {!record.rolBiwo && (
            <Tooltip title={this.props.permisoCambiarContrasena ? "Cambiar Contraseña" : "No disponible"} placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                size="small"
                naranja
                icon={<LockOutlined />}
                onClick={() => this.props.permisoCambiarContrasena && this.abrirCambiarContrasena(value._id)}
                disabled={!this.props.permisoCambiarContrasena}
              />
            </Tooltip>
            )}
            {this.props.tipo === 0 && (
              <Tooltip title="Acceso a la App" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  morado
                  icon={<MobileOutlined />}
                  onClick={() => this.abrirAccesoApp(record)}
                />
              </Tooltip>
            )}
            {this.props.tipo === 0 && record.dosPasos?.activo && (
              <Popconfirm
                title="¿Resetear la verificación en dos pasos? El usuario tendrá que volver a escanear el QR."
                onConfirm={() => this.resetearDosPasos(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Resetear verificación en dos pasos" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    azul
                    icon={<SafetyCertificateOutlined />}
                  />
                </Tooltip>
              </Popconfirm>
            )}
          </div>
        ),
      }
    ]
    const listaUsuarios = (
      <>
        {this.props.tipo === 0 && this.state.usuarioMaster && (
          <Card
            size="small"
            style={{
              marginBottom: 10,
              border: "1px solid #00BFD6",
              borderRadius: 6,
              backgroundColor: "#E6FBFD",
            }}
            bodyStyle={{ padding: "10px 16px" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div style={{ flex: "1 1 220px", minWidth: 160, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <span style={{ fontWeight: "bold", fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {`${this.state.usuarioMaster.nombre || ""} ${this.state.usuarioMaster.apellidoPaterno || ""} ${this.state.usuarioMaster.apellidoMaterno || ""}`.trim()}
                </span>
                <span style={{ fontSize: 12, color: "#888", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {this.state.usuarioMaster.nombreUsuario}
                </span>
              </div>
              <Tag color="cyan" style={{ margin: 0, flex: "0 0 auto" }}>Usuario Master</Tag>
              {this.state.usuarioMaster.correoContacto && (
                <span style={{ flex: "1 1 180px", fontSize: 12, color: "#555", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {this.state.usuarioMaster.correoContacto}
                </span>
              )}
              {this.state.usuarioMaster.celular && (
                <span style={{ flex: "0 0 auto", fontSize: 12, color: "#555" }}>
                  {this.state.usuarioMaster.celular}
                </span>
              )}
              <Badge status="success" text="Activo" style={{ flex: "0 0 auto", whiteSpace: "nowrap" }} />
              <div style={{ flex: "0 0 auto", marginLeft: "auto" }}>
                <Tooltip title="Cambiar Contraseña" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    naranja
                    icon={<LockOutlined />}
                    onClick={() => this.abrirCambiarContrasena(this.props.usuarioPrincipal)}
                  />
                </Tooltip>
              </div>
            </div>
          </Card>
        )}
        <TableItem
          size='small'
          dataSource={this.state.todasUsuarios}
          columns={columns}
          loading={this.state.loading}
          pagination={false}
        />
      </>
    );
    return (
      <>
        <PageHeader
          title="Usuarios"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={this.props.permisoAgregarUsuario ? [
            <ButtonItem
              className="botonAgregar"
              olivo
              type="primary"
              key="agregarPerfil"
              onClick={this.abrirAgregarUsuario.bind(this)}
            >
              Agregar Usuario
            </ButtonItem>,
          ] : []}
        />
        <div style={{ backgroundColor: "white", padding: 20, paddingTop: 10, borderRadius: 12, border: "1px solid rgb(235, 237, 240)" }}>
          <TabbedDynamicTable
            tabs={[
              {
                key: "usuarios",
                label: (
                  <span>
                    <TeamOutlined /> Usuarios
                  </span>
                ),
                customContent: listaUsuarios,
              },
              ...(this.props.permisoAsignarProyecto
                ? [{
                    key: "proyectos",
                    label: (
                      <span>
                        <AppstoreOutlined /> Acceso a proyectos
                      </span>
                    ),
                    customContent: (
                      <AccesoProyectos
                        activo={this.state.tab === "proyectos"}
                        onGuardado={() => this.consultarUsuarios()}
                      />
                    ),
                  }]
                : []),
            ]}
            defaultActiveKey="usuarios"
            onTabChange={(tab) => this.setState({ tab })}
          />
        </div>
        <AgregarUsuario
          visible={this.state.modalAgregarUsuario}
          cerrarAgregarUsuario={this.cerrarAgregarUsuario.bind(this)}
        />
                        <EditarUsuario
          visible={this.state.modalEditarUsuario}
          id={this.state.modalEditarUsuarioId}
          cerrarEditarUsuario={this.cerrarEditarUsuario.bind(this)}
        />
                                <CambiarContrasena
          visible={this.state.modalCambiarContrasena}
          id={this.state.modalCambiarContrasenaId}
          cerrarCambiarContrasena={this.cerrarCambiarContrasena.bind(this)}
        />
        <ModalAccesoApp
          visible={this.state.modalAccesoApp}
          usuarioId={this.state.modalAccesoAppUsuario?._id}
          usuarioNombre={this.state.modalAccesoAppUsuario?.nombre}
          accesoAppActual={!!this.state.modalAccesoAppUsuario?.accesoApp}
          onCancel={this.cerrarAccesoApp.bind(this)}
          onSuccess={this.cerrarAccesoApp.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioPrincipal: state.user.usuarioPrincipal,
    empresaId: state.empresa.id,
    tipo: state.user.tipo,
    appMovil: state.empresa.appMovil,
    permisoUsuariosContadores: state.user.tipo === 0 || !!state.user.permisos.find((valueTodos) => valueTodos.permisoId.toString() === "6ada6ff915d18f8a35a71177")?.activado,
    permisoUsuariosSoporte: state.user.tipo === 0 || !!state.user.permisos.find((valueTodos) => valueTodos.permisoId.toString() === "6ada6fcb39c47705eee6ffb6")?.activado,
    permisoAgregarUsuario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a23141d903358dc7da8a8b7"
      )?.activado,
    permisoEditarUsuario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a23142c903358dc7da8a8bd"
      )?.activado,
    permisoCambiarContrasena:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a231506903358dc7da8a99c"
      )?.activado,
    permisoDeshabilitarUsuario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a231516903358dc7da8a9bb"
      )?.activado,
    permisoAsignarProyecto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a23144f903358dc7da8a8be"
      )?.activado,
  };
};

export default connect(mapStateToProps)(Usuarios);